/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Metadata for a draft with common properties.
 */
export interface DraftMeta {
    /** An entity about which [claims](https://www.w3.org/TR/vc-data-model/#dfn-claims) are made. */
    subject?: string;
    /** The date and time the issued credential is valid from. */
    validFrom?: Date;
    /** The date and time the issued credential valid until. */
    validUntil?: Date;
}
